var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 40 40"}},_vm.$listeners),[_c('path',{attrs:{"stroke":"#0F3228","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","d":"M8.993 19.584H31.84M20.416 8.16L31.84 19.583 20.416 31.007"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }